// extracted by mini-css-extract-plugin
module.exports = {"Submit":"Submit-1a07c","SubmitButton":"SubmitButton-1ln8A","SubmitText":"SubmitText-EjD2f"};